export default __webpack_public_path__ + "static/media/kpp-logo.f475b362.svg";